<template lang="pug">
  div(v-if="!readonly")
    v-label {{ label }} {{ readonly ? ': ' : '' }}
    v-container.pa-0.pt-1
      v-checkbox.mt-0.ml-3(
        v-for="option in choices" :key="option"
        v-model="value"
        :label="option" :value="option"
        color="primary"
        @change="handleChange"
      )
  div(v-else-if="value.length")
    span.subheading.grey--text.text--darken-1 {{ label }} :
    ul
      li(v-for="choice in value") {{ choice }}
</template>

<script>
export default {
  props: {
    choices: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: '',
    },
    value: {
      type: Array,
      default: () => [],
    },
    valueId: {
      type: [Number, String],
      default: null,
    },
    attributeId: {
      type: Number,
      default: null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleChange(value) {
      if (!value || !value.length) {
        if (this.valueId) {
          this.$emit('delete', this.valueId);
        }
      } else {
        if (!this.valueId) {
          this.$emit('post', {attributeId: this.attributeId, value});
        } else {
          this.$emit('put', {valueId: this.valueId, value});
        }
      }
    }
  },
}
</script>

